<template>
<v-form ref="form" @submit.prevent>
  <v-card-text>
    <v-text-field label="輸入您的密碼" :type="showpswd ? 'text':'password'" class="font-weight-bold" outlined v-model="myPassword" :rules="passwordRules" @keyup.enter.prevent="verifyPswd" autocomplete="off">
    </v-text-field>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-text="'繼續'" color="primary" class="mr-2" @click="verifyPswd"></v-btn>
    </v-card-actions>
  </v-card-text>
  </div>
</v-form>
</template>

<script>
export default {
  name: "KeyinPswd",
  props: ["accountId", "password"],
  data() {
    return {
      showpswd: false,
      passwordRules: [
        (v) => !!v || "請輸入密碼",
        //(v) => this.textFieldError || this.errorMessages,
      ],
      custfilelst: [],
    };
  },
  created() { //創建時間節點
    this.$cookie.set('accountId', this.accountId, "0");
  },
  computed: {
    myPassword: {
      get() {
        return this.password;
      },
      set(value) {
        this.$emit("update:password", value);
      },
    },
  },
  methods: {
    verifyPswd() {
      //let url = 'https://queryapi.e-can.com.tw:9091/EDIQRapi/EDIQR_ChkCust/cust_id=' + this.accountId + '&pass=' + this.password + '&main_id=' + this.$cookie.get('dsmid_token')
      let url = 'https://queryapi2.e-can.com.tw:9091/EDIQRapi/EDIQR_ChkCust/cust_id=' + this.accountId + '&pass=' + this.password + '&main_id=' + this.$cookie.get('dsmid_token')
      this.$axios.get(url).then(response => {
        this.custfilelst = response.data;

        if (response.data.cust === '1') {
          //console.log(response.data);
          if (response.data.dsm !== '3') {
            this.$cookie.set('dsm_type', this.custfilelst.dsm, "0");
            //這邊增加cust資料
            this.$cookie.set('password', this.password, "0");
            this.$cookie.set('custname', this.custfilelst.cust_name, "0");
            this.$cookie.set('custphone', this.custfilelst.cust_cellno, "0");
            this.$cookie.set('custtel', this.custfilelst.cust_telno, "0");
            this.$cookie.set('custzipcode', this.custfilelst.cust_zipcode, "0");
            this.$cookie.set('custaddress', this.custfilelst.cust_address, "0");
            this.$router.push({
              name: "VerifyUser"
            });
          } else {
            alert('此宅配單號已經被使用，請重新輸入')
            this.myPassword = ''
            this.$router.push({
              name: "ErrorPage"
            });
          }
        } else {
          alert('帳號密碼錯誤，請重新輸入')
          this.myPassword = ''
          this.$router.push({
            name: "KeyinUser"
          });
        }
      }).catch(function(error) {
        this.$router.push({
          name: "ErrorPage"
        });
      })

    },
    /*setTextFieldError(textFieldError, errorMessages) {
      this.textFieldError = textFieldError;
      this.errorMessages = errorMessages;
    },*/
  },
};
</script>
